(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["greydust-waitlist"]) return;
  try {
    
const shareButton=document.getElementById('gd-share');
if(shareButton){shareButton.addEventListener('click',async()=>{const url=window.location.origin;try{if(navigator.share){await navigator.share({url});}else{await navigator.clipboard.writeText(url);shareButton.textContent=shareButton.dataset.copied;}}catch(error){if(error.name!=='AbortError'){window.prompt(url,url);}}});}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
